import CONFIGURACIONES from "../../../../util/constants";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import React, {useEffect, useState} from "react";
import OWASP from "../../../../util/owasp";

import {el, es} from "date-fns/locale";
import { parse, format, set } from "date-fns";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Http} from "../../../../helpers/Http";
import {Functions} from "../../../../helpers/Functions";
import conFIGURACIONES from "../../../../util/constants";
import EndeudamientosModal from "../../../global/modals/EndeudamientosModal.jsx";
import UnidadFamiliarModal from "../../../global/modals/UnidadFamiliarModal.jsx";
import MercaderiaModal from "../../../global/modals/MercaderiaModal.jsx";
import VentasModal from "../../../global/modals/VentasModal.jsx";
import ActivosModal from "../../../global/modals/ActivosModal.jsx";
import GastoGeneralModal from "../../../global/modals/GastoGeneralModal.jsx";
import EvaluacionCuantitativaModal from "../../../global/modals/EvaluacionCuantitativaModal.jsx";
import EvaluacionCualitativaModal from "../../../global/modals/EvaluacionCualitativaModal.jsx";
import CambiarTasaModal from "../../../global/modals/CambiarTasaModal.jsx";

registerLocale("es-sunday", {
    ...es,
    options: {
        ...es.options,
        weekStartsOn: 0, // 0 = Domingo, 1 = Lunes
    },
});

const MantEvaluationStep02 = ({ MySwal, title, idEdit, showCreate, icon, itemSelected, configuraciones,
        formasPago, clasesPrestamo, categoriasEvaluacion, fnRedirectError, tiposProducto, user, tiposAnexo, showSpinnerLoader, fnRedirectApproval}) => {
    const {handleSubmit, register, getValues, setValue, formState: {errors}} = useForm({mode: "onChange"});
    const [showAccepted, setShowAccepted] = useState(CONFIGURACIONES.INIT.STATUS_TRUE);
    const [activeTab, setActiveTab] = useState("tab1");
    const [showEndeudamiento, setShowEndeudamiento] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [showUnidadFamiliar, setShowUnidadFamiliar] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [showMercaderia, setShowMercaderia] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [showVentas, setShowVentas] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [showActivos, setShowActivos] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [showCambiarTasa, setShowCambiarTasa] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);

    const [showGastoGeneral, setShowGastoGeneral] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [showEvaluacionCuantitativa, setShowEvaluacionCuantitativa] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [showEvaluacionCualitativa, setShowEvaluacionCualitativa] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [teaMinima, setTeaMinima] = useState(CONFIGURACIONES.INIT.NUMBER);
    const [teaMaxima, setTeaMaxima] = useState(CONFIGURACIONES.INIT.NUMBER);
    const [fechaPrimeraCuota, setFechaPrimeraCuota] = useState(CONFIGURACIONES.INIT.STRING);
    const [fechaActual, setFechaActual] = useState(new Date());
    const [initDataActivos, setInitDataActivos] = useState(CONFIGURACIONES.INIT.NULL);
    const [initDataCambiarTasa, setinitDataCambiarTasa] = useState(CONFIGURACIONES.INIT.NULL);
    const [initDataMercaderia, setInitDataMercaderia] = useState(CONFIGURACIONES.INIT.NULL);
    const [initDataVentas, setInitDataVentas] = useState(CONFIGURACIONES.INIT.NULL);
    const [initDataUnidadFamiliar, setInitDataUnidadFamiliar] = useState(CONFIGURACIONES.INIT.NULL);
    const [initDataGastosGenerales, setInitDataGastosGenerales] = useState(CONFIGURACIONES.INIT.NULL);
    const [initDataEvaluacionCuantitativa, setInitDataEvaluacionCuantitativa] = useState(CONFIGURACIONES.INIT.NULL);
    const [initDataEvaluacionCualitativa, setInitDataEvaluacionCualitativa] = useState(CONFIGURACIONES.INIT.NULL);
    const [initDataEndeudamiento, setInitDataEndeudamiento] = useState(CONFIGURACIONES.INIT.NULL);
    const [anexos, setAnexos] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [descuentoVentas, setDescuentoVentas] = useState(CONFIGURACIONES.INIT.NUMBER);

    const onSubmit1 = async (form) => {
        let data = {
            'categoria': form.categoria,
            'numIntegrantesFamilia': form.numIntegrantesFamilia,
            'activoTotal': form.activoTotal,
            'mercaderiaTotal': form.mercaderiaTotal,
            'ventasTotal': form.ventasTotal,
            'gastosGeneralesTotal': form.gastosGeneralesTotal,
            'unidadFamiliarTotal': form.unidadFamiliarTotal,
            'utilidadOperativa': form.utilidadOperativa,
            'utilidadFinalDisponible': form.utilidadFinalDisponible
        };
        
        await Functions().saveApproval(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/enviar-aprobacion/${itemSelected.id}`, user, fnRedirectApproval, fnCalcularCuota, data);
    };

    const fnCerrarEndeudamiento = () => {
        setShowEndeudamiento(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnEndeudamiento = async () => {
        await Functions().getWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/endeudamientos/${itemSelected.id}`, fnInitEndeudamientos);
        setShowEndeudamiento(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnGuardarEndeudamiento = async (data) => {
        if (!showCreate) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/endeudamientos/${itemSelected.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, user, fnSaveEndeudamientoReturn, data);
   
    };

    const fnSaveEndeudamientoReturn = (dataReturn) => {
        updateForm(dataReturn);
        setShowEndeudamiento(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnInitEndeudamientos = (data) => {
        setInitDataEndeudamiento(data);
    };

    const fnUnidadFamiliar = async () => {
        await Functions().getWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/unidad-familiar/${itemSelected.id}`, fnInitUnidadFamiliar);
        setShowUnidadFamiliar(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnInitUnidadFamiliar = (data) => {
        setInitDataUnidadFamiliar(data);
    };

    const fnSaveUnidadFamiliarReturn = (dataReturn) => {
        updateForm(dataReturn);
        setShowUnidadFamiliar(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnCerrarUnidadFamiliar = () => {
        setShowUnidadFamiliar(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnGuardarUnidadFamiliar = async (data) => {
        if (!showCreate) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/unidad-familiar/${itemSelected.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, user, fnSaveUnidadFamiliarReturn, data);
    };

    const fnMercaderia = async () => {
        await Functions().getWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/mercaderia/${itemSelected.id}`, fnInitMercaderias);
        setShowMercaderia(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnInitMercaderias = (data) => {
        setInitDataMercaderia(data);
    };

    const fnSaveMercaderiaReturn = (dataReturn) => {
        updateForm(dataReturn);
        setShowMercaderia(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnCerrarMercaderia = () => {
        setShowMercaderia(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnGuardarMercaderia = async (data) => {
        if (!showCreate) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/mercaderia/${itemSelected.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, user, fnSaveMercaderiaReturn, data);
    };
    

    const fnVentas = async () => {
        await Functions().getWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/ventas/${itemSelected.id}`, fnInitVentas);
        setShowVentas(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnInitVentas = (data) => {
        setInitDataVentas(data);
    };

    const fnCerrarVentas = () => {
        setShowVentas(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnGuardarVentas = async (data) => {
        if (!showCreate) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/ventas/${itemSelected.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, user, fnSaveVentasReturn, data);
    };

    const fnSaveVentasReturn = (dataReturn) => {
        updateForm(dataReturn);
        setShowVentas(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnActivos = async () => {
        await Functions().getWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/activo-total/${itemSelected.id}`, fnInitActivos);
        setShowActivos(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnInitActivos = (data) => {
        setInitDataActivos(data);
    };

    const fnSaveActivosReturn = (dataReturn) => {
        updateForm(dataReturn);
        setShowActivos(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnCerrarActivos = () => {
        setShowActivos(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnGuardarActivos = async (data) => {
        if (!showCreate) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/activo-total/${itemSelected.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, user, fnSaveActivosReturn, data);
    };

    const fnGastoGeneral = async () => {
        await Functions().getWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/gastos-generales/${itemSelected.id}`, fnInitGastosGenerales);
        setShowGastoGeneral(CONFIGURACIONES.INIT.STATUS_TRUE);
    };
    
    const fnInitGastosGenerales = (data) => {
        setInitDataGastosGenerales(data);
    };

    const fnCerrarGastoGeneral = () => {
        setShowGastoGeneral(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnSaveGastosGeneralesReturn = (dataReturn) => {
        updateForm(dataReturn);
        setShowGastoGeneral(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnGuardarGastoGeneral = async (data) => {
        if (!showCreate) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/gastos-generales/${itemSelected.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, user, fnSaveGastosGeneralesReturn, data);
    };

    const fnEvaluacionCuantitativa = async () => {
        await Functions().getWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/evaluacion-cuantitativa/${itemSelected.id}`, fnInitEvaluacionCuantitativa);
        setShowEvaluacionCuantitativa(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnInitEvaluacionCuantitativa = (data) => {
        setInitDataEvaluacionCuantitativa(data);
    };

    const fnCerrarEvaluacionCuantitativa = () => {
        setShowEvaluacionCuantitativa(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnGuardarEvaluacionCuantitativa = async (data) => {
        if (!showCreate) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/evaluacion-cuantitativa/${itemSelected.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, user, fnSaveEvaluacionCuantitativaReturn, data);
    };

    const fnSaveEvaluacionCuantitativaReturn = (dataReturn) => {
        updateForm(dataReturn);
        setShowEvaluacionCuantitativa(CONFIGURACIONES.INIT.STATUS_FALSE);
    };
    
    const fnEvaluacionCualitativa = async () => {
        await Functions().getWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/evaluacion-cualitativa/${itemSelected.id}`, fnInitEvaluacionCualitativa);
        setShowEvaluacionCualitativa(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnInitEvaluacionCualitativa = (data) => {
        setInitDataEvaluacionCualitativa(data);
    };

    const fnCerrarEvaluacionCualitativa = () => {
        setShowEvaluacionCualitativa(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnGuardarEvaluacionCualitativa = async(data) => {
        console.log('data', data);
        
        if (!showCreate) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/evaluacion-cualitativa/${itemSelected.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, user, fnSaveEvaluacionCualitativaReturn, data);
    };

    const fnSaveEvaluacionCualitativaReturn = (dataReturn) => {
        setShowEvaluacionCualitativa(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnAddFile = () => {
        let tipoAnexo = document.getElementById('tipoAnexo');
        let archivo = document.getElementById('archivo');
        if (!tipoAnexo.value || !archivo || !archivo.files || archivo.files.legth === 0) { 
            // alert('Seleccione Tipo de Anexo y/o archivo')
            MySwal.fire({
                title: `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                html: `Seleccione Tipo de Anexo y/o archivo`,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
                cancelButtonColor: "#f62d51",
                confirmButtonColor: "#2962FF"
            });
            return;
        }

        showSpinnerLoader();
        let file = archivo.files[0];
        const formData = new FormData();
        formData.append('tipoAnexo', tipoAnexo.value);
        formData.append('archivo', file);
        formData.append('usuarioRegistro', user?.user);

        Http().post(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/subir-archivo/${itemSelected.id}`, {body: formData}).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                tipoAnexo.value = CONFIGURACIONES.INIT.STRING;
                archivo.value = CONFIGURACIONES.INIT.STRING;
                setAnexos(rpta.data.archivos);
            } else {
                MySwal.fire({
                    title: `<p>${CONFIGURACIONES.MESSAGES.TITLE_ERROR}</p>`,
                    html: `${Object.keys(rpta.errors).length ? Functions().showErrors(rpta.errors) : rpta.message}`,
                    icon: 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    cancelButtonColor: "#f62d51",
                    confirmButtonColor: "#2962FF"
                });
            }
        });
    };

    const fnDeleteFile = async (param) => {
        let data = {
            'id': param.id
        };

        await Functions().deleteElement(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/eliminar-archivo/${itemSelected.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_DELETE_OPERATION, `${CONFIGURACIONES.MESSAGES.DELETES.FILES} <strong>${param.tipoAnexo}</strong>`,  user, dataReturn, data)
    };

    const fnDownloadFile = async (param) => {
        Http().get(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/descargar-archivo/${param.id}`).then(async (rpta) => { 
            if (rpta.ok) {
                const blob = await rpta.blob(); 
                
                const disposition = rpta.headers.get('Content-Disposition');
                let filename = 'downloaded_file'; // Nombre por defecto
                
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }

                // 4. Crear una URL temporal y un enlace invisible
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                
                a.href = url;
                a.download = filename; // Asigna el nombre de archivo
                
                // 5. Simular el click para iniciar la descarga
                document.body.appendChild(a);
                a.click();

                // 6. Limpiar el DOM y revocar la URL temporal
                a.remove();
                window.URL.revokeObjectURL(url);
            }
        });
    };

    const dataReturn = (data) => {
        setAnexos(data.archivos);
    };

    const fnCalcularCuota = () => {
        let tea = getValues('tea');
        let montoSolicitado = getValues('montoSolicitado');
        let plazo = getValues('plazo');
        let formaPagoId = getValues('formaPagoId');
        let diasGracia = getValues('diasGracia');
        let tipoVivienda = getValues('tipoVivienda');

        console.log(`${diasGracia}, ${tea}, ${montoSolicitado}, ${plazo}, ${formaPagoId}`);
        
        // Valida campos requeridos (diasGracia puede ser 0, que es válido)
        if (!itemSelected.id || !tipoVivienda || !tea || !montoSolicitado || !plazo || !formaPagoId || 
            diasGracia === CONFIGURACIONES.INIT.NULL || diasGracia === undefined || 
            diasGracia === CONFIGURACIONES.INIT.STRING ) { return; }
        
        let data = {
            body: {
                'tea': tea,
                'montoSolicitado': montoSolicitado,
                'plazo': plazo,
                'formaPagoId': formaPagoId,
                'diasGracia': diasGracia,
                'solicitudId': itemSelected.id,
                'tipoVivienda': tipoVivienda
            }
        };

        Http().post(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/calcular-cuota/`, data).then((rpta) => {
            setValue('cuota', CONFIGURACIONES.INIT.STRING, { shouldValidate: true });
            setFechaPrimeraCuota(CONFIGURACIONES.INIT.STRING);
           
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                // console.log('rpta', rpta);
                setValue('cuota', rpta.data.cuota);
                setFechaPrimeraCuota(parse(rpta.data.fechaPrimeraCuota, "yyyy-MM-dd", new Date()));
                setValue('fechaPrimeraCuota', parse(rpta.data.fechaPrimeraCuota, "yyyy-MM-dd", new Date()));
            }
        });
    };

    const fnCambiarTasa = async () => {
        await Functions().getWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/cambiar-tasa/${itemSelected.id}`, fnInitCambiarTasa);
        setShowCambiarTasa(CONFIGURACIONES.INIT.STATUS_TRUE);
    };

    const fnGuardarCambiarTasa = async (data) => {
        if (!showCreate) { return; }
        await Functions().saveWithReturn(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/guardar-tasa/${itemSelected.id}`, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION_RATE, user, fnActualizarTasa, data);
    };

    const fnActualizarTasa = (data) => {
        setValue('tea', data.tea);
        setValue('cuota', data.cuota);
        setFechaPrimeraCuota(parse(data.fechaPrimeraCuota, "yyyy-MM-dd", new Date()));
        setValue('fechaPrimeraCuota', parse(data.fechaPrimeraCuota, "yyyy-MM-dd", new Date()));
        setShowCambiarTasa(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnCerrarCambiarTasa = () => {
        setShowCambiarTasa(CONFIGURACIONES.INIT.STATUS_FALSE);
    };

    const fnInitCambiarTasa = (data) => {
        setinitDataCambiarTasa(data);
    };

    
    useEffect(() => {
        if (!itemSelected) { fnRedirectError(); return; }
        setValue('cliente', itemSelected.cliente);
        setValue('tipoDocumento', itemSelected.tipoDocumento);
        setValue('numeroDocumento', itemSelected.numeroDocumento);
        setValue('direccionCasa', itemSelected.direcciones[0].direccion);
        setValue('moneda', itemSelected.moneda);
        setValue('montoSolicitado', itemSelected.montoSolicitado);
        // setValue('frecuencia', itemSelected.frecuencia);
        setValue('plazo', itemSelected.plazo);
        setValue('clasePrestamo', itemSelected.clasePrestamo);
        setValue('formaPago', itemSelected.formaPago);
        setValue('formaPagoId', itemSelected.formaPagoId);
        setValue('categoria', itemSelected.categoria);
        setValue('tipoVivienda', itemSelected.tipoVivienda);
        setValue('cuota', itemSelected.cuota);
        setValue('tea', itemSelected.tea);
        setValue('numIntegrantesFamilia', itemSelected.numIntegrantesFamilia);
        setValue('diasGracia', itemSelected.diasGracia);
        setValue('activoTotal', itemSelected.activoTotal);
        setValue('mercaderiaTotal', itemSelected.mercaderiaTotal);
        setValue('ventasTotal', itemSelected.ventasTotal);
        setValue('gastosGeneralesTotal', itemSelected.gastosGeneralesTotal);
        setValue('unidadFamiliarTotal', itemSelected.unidadFamiliarTotal);
        setValue('utilidadOperativa', itemSelected.utilidadOperativa);
        setValue('utilidadFinalDisponible', itemSelected.utilidadFinalDisponible);
        setAnexos(itemSelected.anexos);
        
        console.log('configuraciones', configuraciones);
        if (configuraciones != CONFIGURACIONES.INIT.NULL) { 
            setDescuentoVentas(parseFloat(configuraciones.descuentoActivo));
        }
       
        tiposProducto.find(tp => tp.id == itemSelected.productoId) && setTeaMinima(tiposProducto.find(tp => tp.id == itemSelected.productoId).tasa_min_interes);
        tiposProducto.find(tp => tp.id == itemSelected.productoId) && setTeaMaxima(tiposProducto.find(tp => tp.id == itemSelected.productoId).tasa_max_interes);

        if (itemSelected.fechaPrimeraCuota != CONFIGURACIONES.INIT.STRING) {
            setFechaPrimeraCuota(parse(itemSelected.fechaPrimeraCuota, "yyyy-MM-dd", new Date()))
            setValue('fechaPrimeraCuota', parse(itemSelected.fechaPrimeraCuota, "yyyy-MM-dd", new Date()));
        }
    }, [itemSelected])  

    const updateForm = (form) => {
        setValue('activoTotal', form?.activoTotal);
        setValue('mercaderiaTotal', form?.mercaderiaTotal);
        setValue('ventasTotal', form?.ventasTotal);
        setValue('gastosGeneralesTotal', form?.gastosGeneralesTotal);
        setValue('unidadFamiliarTotal', form?.unidadFamiliarTotal);
        setValue('utilidadOperativa', form?.utilidadOperativa);
        setValue('utilidadFinalDisponible', form?.utilidadFinalDisponible);

    };

    return (
        <>
            { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
                <div className="card-content">
                    <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                        <div className="row">
                            <div className="col-xs-12 col-md-12">
                                <h5 className="card-title font-weight-bold"><i className={`mdi ${icon}`}></i> {title}</h5>

                                <div className="row mt-3">
                                    <div className="col-md-12">
                                        <div className="d-flex align-items-center pb-2">
                                            <h6 className="mr-2 mb-0">Datos Generales</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-xs-12 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="cliente" className="control-label col-form-label">Cliente <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("cliente", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE
                                                        })}
                                                        className="form-control" id="cliente" placeholder="" />
                                                    <small className="invalid-feedback"> { errors.cliente && errors.cliente.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="tipoDocumento" className="control-label col-form-label">Tipo de Documento <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("tipoDocumento", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE
                                                        })}
                                                        className="form-control" id="tipoDocumento" placeholder="" />
                                                    <small className="invalid-feedback"> { errors.tipoDocumento && errors.tipoDocumento.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="numeroDocumento" className="control-label col-form-label">Num. de Documento <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("numeroDocumento", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE
                                                        })}
                                                        className="form-control" id="numeroDocumento" placeholder="" />
                                                    <small className="invalid-feedback"> { errors.numeroDocumento && errors.numeroDocumento.message }</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-xs-12 col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="direccionCasa" className="control-label col-form-label">Dirección de Casa <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("direccionCasa", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE
                                                        })}
                                                        className="form-control" id="direccionCasa" placeholder="" />
                                                    <small className="invalid-feedback"> { errors.direccionCasa && errors.direccionCasa.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-2">
                                                <div className="form-group">
                                                    <label htmlFor="categoria" className="control-label col-form-label">Categoría <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("categoria", {
                                                            required: OWASP.REQUIRED,
                                                            onChange: (e) => {

                                                            }
                                                        })} className="form-control" id="categoria"  defaultValue={""}
                                                    >
                                                        <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                        {
                                                            CONFIGURACIONES.INIT.LIST.CATEGORIAS.map((el, index) => (
                                                                <option key={index} value={el.id}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.categoria && errors.categoria.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-4">
                                                <div className="form-group">
                                                    <label htmlFor="numIntegrantesFamilia" className="control-label col-form-label">N° de Integrantes de la Familia <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("numIntegrantesFamilia", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            }
                                                        })}
                                                        className="form-control" id="numIntegrantesFamilia" placeholder="" />
                                                    <small className="invalid-feedback"> { errors.numIntegrantesFamilia && errors.numIntegrantesFamilia.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="tipoVivienda" className="control-label col-form-label">Tipo de Vivienda <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("tipoVivienda", {
                                                            required: OWASP.REQUIRED,
                                                            onChange: (e) => {
                                                                let tipoVivienda = e.target.value;
                                                                setValue('tea', teaMinima);
                                                                if(tipoVivienda == CONFIGURACIONES.INIT.LIST_TIPO_VIVIENDA.ALQUILADA) {
                                                                    setValue('tea', teaMaxima);
                                                                }
                                                                fnCalcularCuota();
                                                            }
                                                        })} className="form-control" id="tipoVivienda"  defaultValue={""}
                                                    >
                                                        <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                        {
                                                            CONFIGURACIONES.INIT.LIST.TIPO_VIVIENDA.map((el, index) => (
                                                                <option key={index} value={el.id}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.tipoVivienda && errors.tipoVivienda.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="moneda" className="control-label col-form-label">Moneda <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("moneda", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE
                                                        })}
                                                        className="form-control" id="moneda" name="moneda" placeholder="" />
                                                    <small className="invalid-feedback"> { errors.moneda && errors.moneda.message }</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="clasePrestamo" className="control-label col-form-label">Clase de Préstamo <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("clasePrestamo", {
                                                            required: OWASP.REQUIRED,
                                                            onChange: (e) => {

                                                            }
                                                        })} className="form-control" id="clasePrestamo"  defaultValue={""}
                                                    >
                                                        {
                                                            clasesPrestamo.map((el, index) => (
                                                                <option key={index} value={el.nombre}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small className="invalid-feedback"> { errors.clasePrestamo && errors.clasePrestamo.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="formaPagoId" className="control-label col-form-label">Forma de Pago <span className="text-danger">*</span></label>
                                                    <select
                                                        {...register("formaPagoId", {
                                                            required: OWASP.REQUIRED,
                                                            onChange: (e) => {
                                                                setValue('formaPagoId', e.target.value);
                                                                fnCalcularCuota();
                                                            }
                                                        })} className="form-control" id="formaPagoId"  defaultValue={""}
                                                    >
                                                        <option value="" disabled>Seleccione</option>
                                                        {
                                                            formasPago.map((el, index) => (
                                                                <option key={index} value={el.id}>{el.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <input type="hidden" name="formaPago" {...register("formaPago", {required: OWASP.REQUIRED})} />
                                                    <small className="invalid-feedback"> { errors.formaPagoId && errors.formaPagoId.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="plazo" className="control-label col-form-label">Num. de Cuotas <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("plazo", {
                                                            required: OWASP.REQUIRED,
                                                            onChange: (e) => {
                                                                setValue('plazo', e.target.value);
                                                                fnCalcularCuota();
                                                            }
                                                        })}
                                                        className="form-control" id="plazo" placeholder="" />
                                                    <small className="invalid-feedback"> { errors.plazo && errors.plazo.message }</small>
                                                </div>
                                            </div>

                                            {/* <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="frecuencia" className="control-label col-form-label">Frecuencia <small>(días)</small> <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("frecuencia", {
                                                            required: OWASP.REQUIRED,
                                                        })}
                                                        className="form-control" id="frecuencia" placeholder="" readOnly={CONFIGURACIONES.INIT.STATUS_TRUE} />
                                                    <small className="invalid-feedback"> { errors.frecuencia && errors.frecuencia.message }</small>
                                                </div>
                                            </div> */}

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="montoSolicitado" className="control-label col-form-label">Monto Solicitado <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("montoSolicitado", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: CONFIGURACIONES.INIT.STATUS_TRUE
                                                        })}
                                                        className="form-control" id="montoSolicitado" placeholder="" />
                                                    <small className="invalid-feedback"> { errors.montoSolicitado && errors.montoSolicitado.message }</small>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="tea" className="control-label col-form-label">Tasa <span className="text-danger">*</span></label>
                                                    <div className="input-group">
                                                        <input
                                                            {...register("tea", {
                                                                required: OWASP.REQUIRED,
                                                                disabled: conFIGURACIONES.INIT.STATUS_TRUE,
                                                            })}
                                                            className="form-control"
                                                            id="tea"
                                                            placeholder=""
                                                        />
                                                        
                                                        {/* Contenedor del botón a la derecha */}
                                                        <div className="input-group-append">
                                                            <WaveButton type="button" className="btn btn-sm btn-outline-info waves-effect" onClick={fnCambiarTasa}>
                                                                Cambiar
                                                            </WaveButton>
                                                        </div>
                                                    </div>
                                                    <small className="invalid-feedback"> { errors.tea && errors.tea.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="diasGracia" className="control-label col-form-label">Días de Gracia <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("diasGracia", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.ONLY_NUMBER_DAYS_GRACIA,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            },
                                                            onChange: (e) => {
                                                                setValue('diasGracia', e.target.value);
                                                                fnCalcularCuota();
                                                            }
                                                        })}
                                                        className="form-control" id="diasGracia" placeholder="" />
                                                    <small className="invalid-feedback"> { errors.diasGracia && errors.diasGracia.message }</small>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="fechaPrimeraCuotaDataPicker" className="control-label col-form-label">Fecha de Primera Cuota <span className="text-danger">*</span></label>

                                                    <DatePicker dateFormat={"dd/MM/yyyy"} 
                                                        id="fechaPrimeraCuotaDataPicker"
                                                        placeholderText="dd / mm / aaaa" 
                                                        className="form-control text-center"
                                                        locale="es-sunday"
                                                        selected={fechaPrimeraCuota}
                                                        dayClassName={(date) =>
                                                            date.getDay() === 0 || date.getDay() === 6? "weekend-day" : undefined
                                                        }
                                                        onChange={(date) => {
                                                            setFechaPrimeraCuota(date);
                                                            setValue("fechaPrimeraCuota",  format(date, "yyyy-MM-dd"), 
                                                            { shouldValidate: true });
                                                        }}
                                                        onChangeRaw={(e) => e.preventDefault()}
                                                        disabled={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                        popperClassName="datepicker-popper"
                                                        minDate={fechaActual}
                                                    />
                                                    <input 
                                                        {...register("fechaPrimeraCuota", {
                                                            required: OWASP.REQUIRED,
                                                            pattern: {
                                                                value: OWASP.VALIDATIONS.DATE,
                                                                message: OWASP.MESSAGES.DEFAULT
                                                            }
                                                        })}
                                                        type="hidden" />
                                                    <small className="invalid-feedback"> { errors.fechaPrimeraCuota && errors.fechaPrimeraCuota.message }</small>           
                                                </div>
                                            </div>

                                            <div className="col-xs-12 col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="cuota" className="control-label col-form-label">Cuota <span className="text-danger">*</span></label>
                                                    <input
                                                        {...register("cuota", {
                                                            required: OWASP.REQUIRED,
                                                            disabled: conFIGURACIONES.INIT.STATUS_TRUE,
                                                        })}
                                                        className="form-control" id="cuota" placeholder="" />
                                                    <small className="invalid-feedback"> { errors.cuota && errors.cuota.message }</small>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <hr className="pt-1 bg-success"/>

                                <div className="container px-0 mx-0 mt-4">
                                    {/* Nav tabs */}
                                    <ul className="nav nav-tabs custom-tabs">
                                        <li className="nav-item">
                                            <button type="button"
                                                className={`nav-link ${activeTab === "tab1" ? "active" : ""}`}
                                                onClick={() => setActiveTab("tab1")}
                                            >
                                                Evaluación
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button type="button"
                                                className={`nav-link ${activeTab === "tab2" ? "active" : ""}`}
                                                onClick={() => setActiveTab("tab2")}
                                            >
                                                Documentos
                                            </button>
                                        </li>
                                    </ul>

                                    {/* Tab content */}
                                    <div className="tab-content p-3 tab-content-clean">
                                        {activeTab === "tab1" && (
                                            <div className="tab-pane fade show active">
                                               <div className="row">
                                                   <div className="col-xs-12 col-md-6">
                                                       <h6>Balance</h6>
                                                       <div className="form-group row align-items-center mb-2">
                                                           <label className="col-sm-4 col-form-label">
                                                               Endeudamiento <span className="text-danger">*</span>
                                                           </label>
                                                           <div className="col-sm-1">
                                                               <WaveButton type="button" className="btn btn-sm btn-outline-secondary ml-auto" onClick={fnEndeudamiento}>
                                                                   Detalle
                                                               </WaveButton>
                                                           </div>
                                                       </div>


                                                       <div className="form-group row align-items-center mb-1">
                                                           <label
                                                               htmlFor="activoTotal"
                                                               className="col-sm-4 col-form-label"
                                                           >
                                                               Activo Total <span className="text-danger">*</span>
                                                           </label>
                                                           <div className="col-sm-4">
                                                               <input
                                                                   type="text"
                                                                   name="activoTotal"
                                                                   id="activoTotal"
                                                                   className="form-control form-control-sm"
                                                                   readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                                   {...register("activoTotal", {
                                                                        required: OWASP.REQUIRED,
                                                                        pattern: {
                                                                            value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                                            message: OWASP.MESSAGES.DEFAULT
                                                                        }
                                                                   })}
                                                               />
                                                           </div>
                                                           <div className="col-sm-1">
                                                               <WaveButton type="button" className="btn btn-sm btn-outline-secondary ml-auto" onClick={fnActivos}>
                                                                   Detalle
                                                               </WaveButton>
                                                           </div>
                                                       </div>

                                                       <div className="form-group row align-items-center mb-1">
                                                           <label
                                                               htmlFor="mercaderiaTotal"
                                                               className="col-sm-4 col-form-label"
                                                           >
                                                               Mercadería <span className="text-danger">*</span>
                                                           </label>
                                                           <div className="col-sm-4">
                                                               <input
                                                                   type="text"
                                                                   name="mercaderiaTotal"
                                                                   id="mercaderiaTotal"
                                                                   className="form-control form-control-sm"
                                                                   readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                                   {...register("mercaderiaTotal", {
                                                                        required: OWASP.REQUIRED,
                                                                        pattern: {
                                                                            value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                                            message: OWASP.MESSAGES.DEFAULT
                                                                        }
                                                                   })}
                                                               />
                                                           </div>
                                                           <div className="col-sm-1">
                                                               <WaveButton className="btn btn-sm btn-outline-secondary ml-auto wave-effect" onClick={fnMercaderia}>
                                                                   Detalle
                                                               </WaveButton>
                                                           </div>
                                                        </div>

                                                        <div className="form-group row align-items-center mb-1">
                                                           <label
                                                               htmlFor="evaluacionCuantitativa"
                                                               className="col-sm-4 col-form-label"
                                                           >
                                                               Evaluación Cuantitativa <span className="text-danger">*</span>
                                                           </label>
                                                           <div className="col-sm-1">
                                                               <WaveButton className="btn btn-sm btn-outline-secondary ml-auto" type="button" onClick={fnEvaluacionCuantitativa}>
                                                                   Detalle
                                                               </WaveButton>
                                                           </div>
                                                       </div>
                                                       
                                                       <div className="form-group row align-items-center mb-1">
                                                           <label
                                                               htmlFor="evaluacionCualitativa"
                                                               className="col-sm-4 col-form-label"
                                                           >
                                                               Evaluación Cualitativa <span className="text-danger">*</span>
                                                           </label>
                                                           <div className="col-sm-1">
                                                               <WaveButton className="btn btn-sm btn-outline-secondary ml-auto" type="button" onClick={fnEvaluacionCualitativa}>
                                                                   Detalle
                                                               </WaveButton>
                                                           </div>
                                                       </div>
                                                   </div>

                                                   <div className="col-xs-12 col-md-6">
                                                       <h6>Estado de Ganancias y Pérdidas</h6>
                                                       <div className="form-group row align-items-center mb-1">
                                                           <label
                                                               htmlFor="ventasTotal"
                                                               className="col-sm-5 col-form-label"
                                                           >
                                                               Ventas <span className="text-danger">*</span>
                                                           </label>
                                                           <div className="col-sm-4">
                                                               <input
                                                                   type="text"
                                                                   name="ventasTotal"
                                                                   id="ventasTotal"
                                                                   className="form-control form-control-sm"
                                                                   readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                                    {...register("ventasTotal", {
                                                                        required: OWASP.REQUIRED,
                                                                        pattern: {
                                                                            value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                                            message: OWASP.MESSAGES.DEFAULT
                                                                        }
                                                                    })}
                                                               />
                                                           </div>
                                                           <div className="col-sm-1">
                                                               <WaveButton type="button" className="btn btn-sm btn-outline-secondary ml-auto wave-effect" onClick={fnVentas}>
                                                                   Detalle
                                                               </WaveButton>
                                                           </div>
                                                       </div>

                                                       <div className="form-group row align-items-center mb-1">
                                                           <label
                                                               htmlFor="gastosGeneralesTotal"
                                                               className="col-sm-5 col-form-label"
                                                           >
                                                               Gastos Generales <span className="text-danger">*</span>
                                                           </label>
                                                           <div className="col-sm-4">
                                                               <input
                                                                   type="text"
                                                                   name="gastosGeneralesTotal"
                                                                   id="gastosGeneralesTotal"
                                                                   className="form-control form-control-sm"
                                                                   readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                                   {...register("gastosGeneralesTotal", {
                                                                        required: OWASP.REQUIRED,
                                                                        pattern: {
                                                                            value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                                            message: OWASP.MESSAGES.DEFAULT
                                                                        }
                                                                   })}
                                                               />
                                                           </div>
                                                           <div className="col-sm-1">
                                                               <button className="btn btn-sm btn-outline-secondary ml-auto" type="button" onClick={fnGastoGeneral}>
                                                                   Detalle
                                                               </button>
                                                           </div>
                                                       </div>

                                                       <div className="form-group row align-items-center mb-1">
                                                           <label
                                                               htmlFor="unidadFamiliarTotal"
                                                               className="col-sm-5 col-form-label"
                                                           >
                                                               Unidad Familiar <span className="text-danger">*</span>
                                                           </label>
                                                           <div className="col-sm-4">
                                                               <input
                                                                   type="text"
                                                                   name="unidadFamiliarTotal"
                                                                   id="unidadFamiliarTotal"
                                                                   className="form-control form-control-sm"
                                                                   readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                                   {...register("unidadFamiliarTotal", {
                                                                        required: OWASP.REQUIRED,
                                                                        pattern: {
                                                                            value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                                            message: OWASP.MESSAGES.DEFAULT
                                                                        }
                                                                   })}
                                                               />
                                                           </div>
                                                           <div className="col-sm-1">
                                                               <WaveButton className="btn btn-sm btn-outline-secondary ml-auto" onClick={fnUnidadFamiliar}>
                                                                   Detalle
                                                               </WaveButton>
                                                           </div>
                                                       </div>


                                                       <div className="form-group row align-items-center mb-1">
                                                           <label
                                                               htmlFor="utilidadOperativa"
                                                               className="col-sm-5 col-form-label"
                                                           >
                                                               Utilidad Operativa <span className="text-danger">*</span>
                                                           </label>
                                                           <div className="col-sm-4">
                                                               <input
                                                                   type="text"
                                                                   name="utilidadOperativa"
                                                                   id="utilidadOperativa"
                                                                   className="form-control form-control-sm"
                                                                   readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                                   {...register("utilidadOperativa", {
                                                                        required: OWASP.REQUIRED,
                                                                        pattern: {
                                                                            value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                                            message: OWASP.MESSAGES.DEFAULT
                                                                        }
                                                                   })}
                                                               />
                                                           </div>
                                                       </div>

                                                       <div className="form-group row align-items-center mb-1">
                                                           <label
                                                               htmlFor="utilidadFinalDisponible"
                                                               className="col-sm-5 col-form-label"
                                                           >
                                                               Utilidad Final Disponible <span className="text-danger">*</span>
                                                           </label>
                                                           <div className="col-sm-4">
                                                               <input
                                                                   type="text"
                                                                   name="utilidadFinalDisponible"
                                                                   id="utilidadFinalDisponible"
                                                                   className="form-control form-control-sm"
                                                                   readOnly={CONFIGURACIONES.INIT.STATUS_TRUE}
                                                                   {...register("utilidadFinalDisponible", {
                                                                        required: OWASP.REQUIRED,
                                                                        pattern: {
                                                                            value: OWASP.VALIDATIONS.ONLY_MONEY,
                                                                            message: OWASP.MESSAGES.DEFAULT
                                                                        }
                                                                   })}
                                                               />
                                                           </div>
                                                       </div>
                                                   </div>
                                               </div>
                                            </div>
                                        )}
                                        {activeTab === "tab2" && (
                                            <div className="tab-pane fade show active">
                                                <div className="row">
                                                    {/* <div className="col-xs-12 col-md-6">
                                                        <div className="tree-container">
                                                            <Tree
                                                                data={data}
                                                                openByDefault={true}
                                                                indent={20}
                                                                rowHeight={24}
                                                                onSelect={handleSelect}
                                                                render={(node) => (
                                                                    <div
                                                                        className={`tree-node ${node.isSelected ? "selected" : ""}`}
                                                                        onClick={() => {
                                                                            if (node.isInternal) node.toggle();
                                                                            node.select();
                                                                        }}
                                                                    >
                                                                        <span className="icon">
                                                                          {node.isInternal ? (node.isOpen ? "📂" : "📁") : "📄"}
                                                                        </span>
                                                                        <span className="label">{node.data.name}</span>
                                                                    </div>
                                                                )}
                                                            />
                                                        </div>
                                                    </div> */}

                                                    <div className="col-xs-12 col-md-10">
                                                        <div className="table-responsive">
                                                            <table className="table table-bordered compact-table align-middle text-nowrap">
                                                                <thead className="table-warning">
                                                                <tr>
                                                                    <th>Tipo de Archivo</th>
                                                                    {/* <th>Nombre de Archivo</th> */}
                                                                    <th>Fecha de Subida</th>
                                                                    <th>Adjuntado Por</th>
                                                                    <th></th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {anexos.length > 0? (
                                                                    anexos.map((item) => (
                                                                    <tr key={item.id}>
                                                                        <td>{item.tipoAnexo}</td>
                                                                        {/* <td>{item.nombreArchivo}</td> */}
                                                                        <td>{item.fechaRegistro}</td>
                                                                        <td>{item.usuarioRegistro}</td>
                                                                        <td>
                                                                            <WaveButton type="button" className="btn btn-sm btn-outline-info" onClick={() => fnDownloadFile(item)}>
                                                                                <i className="mdi mdi-eye"></i>
                                                                            </WaveButton>
                                                                            <WaveButton type="button" className="btn btn-sm btn-outline-danger ml-2" onClick={() => fnDeleteFile(item)}>
                                                                                <i className="mdi mdi-delete"></i>
                                                                            </WaveButton>
                                                                        </td>
                                                                    </tr>
                                                                    ))
                                                                ):(
                                                                    <tr>
                                                                        <td colSpan="4" className="text-center text-muted">
                                                                            <span className="text-danger">No se encontraron resultados</span>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-4 col-xs-12">
                                                                <label htmlFor="tipoAnexo" className="control-label col-form-label">Tipo <span className="text-danger">*</span></label>
                                                                <select className="form-control" id="tipoAnexo" 
                                                                    placeholder="" defaultValue={""}
                                                                >
                                                                    <option value="" disabled>Seleccione</option>
                                                                    {
                                                                        tiposAnexo.map((el, index) => (
                                                                            <option key={index} value={el.nombre}>{el.nombre}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                <small className="invalid-feedback"> { errors.tipoAnexo && errors.tipoAnexo.message }</small>
                                                            </div>

                                                            <div className="col-md-4 col-xs-12">
                                                                <div className="form-group">
                                                                    <label htmlFor="archivo" className="control-label col-form-label">Archivo <span className="text-danger">*</span></label>
                                                                    <input type="file" id="archivo" className="form-control" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-3 col-xs-12">
                                                                <WaveButton id="btnSubirArchivo" type="button" className="btn btn-sm btn-outline-info waves-effect" onClick={fnAddFile}>
                                                                    <i className="mdi mdi-arrow-up-bold"></i> Subir Archivo
                                                                </WaveButton>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === "tab3" && (
                                            <div className="tab-pane fade show active">
                                                <h5>Contenido de la pestaña 3</h5>
                                                <p>Este es el contenido para la tercera pestaña.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="action-form mt-3 d-flex justify-content-end">
                            <div className="form-group m-0 p-0 text-left">
                                {showCreate && <WaveButton type="button" className="btn btn-sm btn-outline-danger waves-effect" onClick={fnRedirectError}>
                                    <i className="mdi mdi-arrow-left"></i> Descartar
                                </WaveButton>}

                                {showCreate && showAccepted && <WaveButton type="submit" className="btn btn-sm btn-outline-success ml-2 waves-effect">
                                    <i className="mdi mdi-arrow-right-bold"></i> Enviar a Aprobación
                                </WaveButton>}
                            </div>
                        </div>
                    </form>
                    <EndeudamientosModal show={showEndeudamiento} title={"Endeudamiento Interno & Externo"} onClose={fnCerrarEndeudamiento} showCreate={showCreate} onSave={fnGuardarEndeudamiento} categoriasEvaluacion={categoriasEvaluacion} initDataEndeudamiento={initDataEndeudamiento} solicitudId={itemSelected &&  itemSelected.id} />
                    <UnidadFamiliarModal show={showUnidadFamiliar} title={"Detalle de Unidad Familiar"} onClose={fnCerrarUnidadFamiliar} showCreate={showCreate} onSave={fnGuardarUnidadFamiliar} categoriasEvaluacion={categoriasEvaluacion} initDataUnidadFamiliar={initDataUnidadFamiliar} />
                    <MercaderiaModal show={showMercaderia} title={"Detalle de Mercadería"} onClose={fnCerrarMercaderia} showCreate={showCreate} onSave={fnGuardarMercaderia} categoriasEvaluacion={categoriasEvaluacion} initDataMercaderia={initDataMercaderia} />
                    <VentasModal show={showVentas} title={"Detalle de Ventas"} onClose={fnCerrarVentas} showCreate={showCreate} onSave={fnGuardarVentas} descuentoVentas={descuentoVentas} initDataVentas={initDataVentas} />
                    <ActivosModal show={showActivos} title={"Detalle de Activos"} onClose={fnCerrarActivos} showCreate={showCreate} onSave={fnGuardarActivos} categoriasEvaluacion={categoriasEvaluacion} initDataActivos={initDataActivos}/>
                    <CambiarTasaModal show={showCambiarTasa} title={"Cambiar Tasa"} onClose={fnCerrarCambiarTasa} showCreate={showCreate} onSave={fnGuardarCambiarTasa} initDataTasa={initDataCambiarTasa} />
                    <GastoGeneralModal show={showGastoGeneral} title={"Detalle de Gastos Generales"} onClose={fnCerrarGastoGeneral} showCreate={showCreate} onSave={fnGuardarGastoGeneral} categoriasEvaluacion={categoriasEvaluacion} initDataGastosGenerales={initDataGastosGenerales} />
                    <EvaluacionCuantitativaModal show={showEvaluacionCuantitativa} title={"Detalle de Evaluación Cuantitativa"} onClose={fnCerrarEvaluacionCuantitativa} showCreate={showCreate} onSave={fnGuardarEvaluacionCuantitativa} initDataEvaluacionCuantitativa={initDataEvaluacionCuantitativa} solicitudId={itemSelected &&  itemSelected.id} />
                    <EvaluacionCualitativaModal show={showEvaluacionCualitativa} title={"Detalle de Evaluación Cualitativa"} onClose={fnCerrarEvaluacionCualitativa} showCreate={showCreate} onSave={fnGuardarEvaluacionCualitativa} categoriasEvaluacion={categoriasEvaluacion} initDataEvaluacionCualitativa={initDataEvaluacionCualitativa} />
                </div>
            </>
            }
        </>
    )
}
export default MantEvaluationStep02;